
import React, { useEffect, useState } from 'react'
import { Button, FormControl, IconButton, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { SearchOutlined } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import {resetFilter} from '../redux/slices/usersSlice';
import {searchUsers} from '../api/APIServices'
import { useDispatch } from 'react-redux';

function Search() {
    const dispatch = useDispatch();

    const [showForm, setShowForm] = useState(false);
    const [enrollmentDate, setEnrollmentDate] = useState({month:'', year:''})
    const [dob, setDob] = useState(null)
    const [name, setName] = useState({firstName:'', lastName:''});

    function handleNameChange(e){
      const {name, value} = e.target;
      let fName= '';
      let lName= '';
      let fullName = '';
      if(value) {
        fullName = value.split(' ');
        fName = (fullName[0]) ? fullName[0]: null;
        lName = (fullName[1]) ? fullName[1]: null;
      }
      setName({firstName:fName,lastName:lName });
    }

    function handelEnrollmentYear(e){
     let sDate = dayjs(e).format('YYYY-MM-DD');
      let year = null;
      if(sDate !== 'Invalid Date'){
        year = sDate.substring(0,4);
      }
      setEnrollmentDate({...enrollmentDate, ['year']:year})
    }

    function handelEnrollmentMonth(e){
      let sDate = new Date(e); 
      let month=null;
      if(sDate !== 'Invalid Date'){
        month = sDate.getMonth()+1;
        month = (month <= 9) ? "0"+month : month;
      }
      setEnrollmentDate({...enrollmentDate, ['month']:month})
    }
 

    function searchData(){
      let eDate, year, month=null;
      if(enrollmentDate.year){
        eDate=year=enrollmentDate.year
      }
      if(enrollmentDate.month){
        eDate=month=enrollmentDate.month
      }
      if(year && month){
        eDate = `${year}-${month}`;
      }
      const filters = {
        fullname: `${name.firstName} ${name.lastName}`,
        firstName: name.firstName,
        lastName:name.lastName,
        dob:dob,
        enrollmentDate: eDate,
        userType:'user',
        isFilter:true
      }
      if(Object.values(filters).length > 0){
          dispatch(searchUsers(filters));
          setShowForm(false);
      }
    }

    function reset() {
      setName({firstName:'', lastName:''});
      setDob(null);
      setEnrollmentDate({month:'', year:''});
      setShowForm(false);
      dispatch(resetFilter());
    }
    return(
      <div style={{position: 'relative', paddingTop: '2px', marginRight: '10px'}}>
        <div style={{zIndex: '2', position: 'relative'}}>
            <SearchIcon style={{ color: '#001D2B', margin:'0px 10px' }} onClick={() => setShowForm(prev => !prev)}  color={'primary'}/>
            {/* <RestartAltIcon onClick={reset} /> */}
         </div>
        
        {showForm && <div className='search-form'>
            
            <TextField sx={{marginBottom:'10px'}}  size="small" id="outlined-basic" 
                label="Search Name" variant="outlined" 
                onChange={handleNameChange}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchOutlined onClick={searchData}/>
                    </IconButton>
                  ),
                }}/>
             
                <LocalizationProvider size="small" dateAdapter={AdapterDayjs}>
                  <DateField 
                  label='Date of Birth'
                    sx={{marginBottom:'10px'}}
                    slotProps={{ textField: { size: 'small' } }}
                    onChange={(dt)=> setDob(dayjs(dt).format('YYYY-MM-DD'))} 
                  />
                </LocalizationProvider>
                <div>
                  <Typography  sx={{color:'#a19c9c', fontSize:'smaller', textAlign:'left'}} component={'div'}>
                    Enrollment Month / Year
                  </Typography>
                  <div style={{display:'flex'}}>
                    <div>
                      <LocalizationProvider size="small" dateAdapter={AdapterDayjs}>
                        <DateField 
                        // label='Month'
                          format='MM'
                          name="month"
                          sx={{marginBottom:'10px', marginRight:'10px'}}
                          slotProps={{ textField: { size: 'small' } }}
                          onChange={handelEnrollmentMonth}
                        />
                      </LocalizationProvider>
                    </div>
                    <div>
                      <LocalizationProvider size="small" dateAdapter={AdapterDayjs}>
                        <DateField 
                          format='YYYY'
                          name="year"
                          sx={{marginBottom:'10px'}}
                          slotProps={{ textField: { size: 'small' } }}
                          onChange={handelEnrollmentYear}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
             
              <div style={{marginTop:'10px'}}>
                <Button onClick={searchData} size="small" sx={{marginRight:'5px'}} variant="outlined" startIcon={<SearchIcon />}>
                  Search
                </Button>
                <Button  size="small" onClick={reset} variant="outlined" startIcon={<RestartAltIcon />}>
                  Reset
                </Button>
              </div>
           
          </div>
          }
      </div>
    );

}

export default Search